import { useEffect } from "react";
import {
    useCurrentRapidData,
    useUser,
    useInitializeModelFromRapidData,
    useFetchCurrentModelMetrics,
    useFetchComparisonSources,
    useCurrentModelChange,
    useModelPageState,
    useCurrentWorkspace,
    useApiKeyForWorkspace
} from "@/store";
import { ModelPageState } from "../types";

export function useModelPage() {
    const rapidData = useCurrentRapidData();
    const user = useUser();
    const currentWorkspace = useCurrentWorkspace();
    const apiKey = useApiKeyForWorkspace(currentWorkspace?.id || "");
    const initializeModel = useInitializeModelFromRapidData();
    const fetchMetrics = useFetchCurrentModelMetrics();
    const fetchComparisonSources = useFetchComparisonSources();
    const currentModelChange = useCurrentModelChange();
    const modelPageState = useModelPageState();

    // Initialize model state from rapid data
    useEffect(() => {
        if (rapidData && user?.uid) {
            console.log("[useModelPage] Initializing with rapidData:", {
                id: rapidData.id,
                models: rapidData.models,
                modelChanges: rapidData.modelChanges
            });
            initializeModel(rapidData, user.uid);
        }
    }, [rapidData, user?.uid, initializeModel]);

    // Fetch metrics when current model change is set and has a version ref
    useEffect(() => {
        if (currentModelChange?.to?.ref) {
            fetchMetrics();
        }
    }, [currentModelChange?.to?.ref, fetchMetrics]);

    // Fetch comparison sources when we're in comparison or single model mode and have the model data
    useEffect(() => {
        if (
            rapidData?.id &&
            apiKey &&
            currentModelChange &&
            (modelPageState === ModelPageState.NEW_MODEL_COMPARISON ||
                modelPageState === ModelPageState.HISTORICAL_COMPARISON ||
                modelPageState === ModelPageState.SINGLE_MODEL_PERFORMANCE)
        ) {
            console.log("[useModelPage] Fetching comparison sources for:", rapidData.id);
            fetchComparisonSources(rapidData.id, apiKey);
        }
    }, [rapidData?.id, apiKey, currentModelChange?.id, modelPageState, fetchComparisonSources]);
}
